export default __webpack_public_path__ + "assets/png/b331bff4d8aedc4ee0c0389829a50954.png";